import { create } from "zustand";
import { InvestorAmlHistoryItem } from "../api/transformers/aml";
import { AmlAPI } from "../api";
import { first } from "lodash";

export type InvestorAmlHistorStore = {
  data: InvestorAmlHistoryItem[] | null,
  loading: boolean;
  error: unknown | null;
  getLatestHistory: () => InvestorAmlHistoryItem | undefined;
  fetchData: (personId: string) => void;
}

const useInvestorAmlHistoryStore = create<InvestorAmlHistorStore>((set, get) => ({
  data: null,
  loading: true,
  error: null,
  getLatestHistory: () => first(get().data),
  // actions
  fetchData: async (personId: string) => {
    set({ loading: true, error: null, data: null });
    try {
      const result = await AmlAPI.getInvestorAmlHistory(personId);
      set({ data: result, loading: false });
    } catch (err) {
      console.error(err);
      set({ error: err, loading: false });
    }
  }
}));

export default useInvestorAmlHistoryStore;
